import styled from 'styled-components';

const TimeplanList = styled.ol``;

export default TimeplanList;
